module.exports = __webpack_public_path__ + "img/palm2_1.7bfec9f9.png";